import React from 'react';
import { Link } from 'react-router-dom';
import './LegalBar.css';

// Minimal, self-contained legal links strip shown at the bottom of every
// storefront page. Kept separate from the full marketing Footer (currently
// hidden — see App.css) so Privacy/Terms stay reachable regardless of that
// component's state.
const LegalBar = () => (
  <div className="legal-bar">
    <span>© {new Date().getFullYear()} Bikini World Kenya</span>
    <span className="legal-bar-sep">·</span>
    <div className="legal-bar-links">
      <Link to="/privacy">Privacy Policy</Link>
      <span className="legal-bar-sep">·</span>
      <Link to="/terms">Terms of Use</Link>
    </div>
  </div>
);

export default LegalBar;
